import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-favourite-job',
  templateUrl: './favourite-job.component.html',
  styleUrls: ['./favourite-job.component.scss']
})
export class FavouriteJobComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
